<div class="flex gap-1" data-id="assistant-feedback-buttons">
  <p-button
    data-id="assistant-thumbs-up"
    [styleClass]="'bd-neutral bd-size-small'"
    [icon]="feedbackState() === 'up' ? 'ui-thumbs-up-solid' : 'ui-thumbs-up'"
    [text]="true"
    (onClick)="onThumbsUp()"
  ></p-button>
  <p-button
    data-id="assistant-thumbs-down"
    [styleClass]="'bd-neutral bd-size-small'"
    [icon]="
      feedbackState() === 'down' ? 'ui-thumbs-down-solid' : 'ui-thumbs-down'
    "
    [text]="true"
    (onClick)="onThumbsDown()"
  ></p-button>
</div>
